import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Favorite } from '~/models/modules/favorite';
import { ApiServiceBase, API_NAMES } from '~/services/api';

@Injectable({ providedIn: 'root' })
export class FavoritesService extends ApiServiceBase {
    constructor(injector: Injector, private http: HttpClient) {
        super(injector);
        this.setBase(API_NAMES.common);
    }

    getFavorites() {
        return this.http.get<Favorite[]>(this._url());
    }

    updateFavorites(model: any) {
        return this.client.put<any>(this._url(), model);
    }

    private _url(v?: string | undefined) {
        v = v || '';
        return this.url(`/Favorites${v}`);
    }
}
